export default String.raw`
{
  "short_name": "e-Sklep",
  "name": "e-Sklep",
  "icons": [
    {
      "src": "../icon_192.png",
      "type": "image/png",
      "sizes": "192x192",
      "purpose": "any maskable"
    },
    {
      "src": "../icon_512.png",
      "type": "image/png",
      "sizes": "512x512",
      "purpose": "any maskable"
    }
  ],
  "start_url": "../",
  "background_color": "#ffffff",
  "display": "minimal-ui",
  "theme_color": "#934346"
}
`